import { render, staticRenderFns } from "./AddNewQualification.vue?vue&type=template&id=fbdc3066&scoped=true"
import script from "./AddNewQualification.vue?vue&type=script&lang=js"
export * from "./AddNewQualification.vue?vue&type=script&lang=js"
import style0 from "./AddNewQualification.vue?vue&type=style&index=0&id=fbdc3066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdc3066",
  null
  
)

export default component.exports